import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';


function FormattedPrimeRateMessage({ value, primeRate }) {
    const deltaPrime = (value - primeRate) / 100;

    return (
        <FormattedMessage
            id="mtg-common.FormattedPrimeRateMessage.primeRate"
            defaultMessage="Prime {operator} {deltaPrime, number, percent2}"
            values={{ 
                deltaPrime: Math.abs(deltaPrime),
                operator: deltaPrime > 0 ? '+' : '-',
            }}
        />
    );
}

FormattedPrimeRateMessage.propTypes = {
    value: PropTypes.number.isRequired,
    primeRate: PropTypes.number.isRequired,
};

export default FormattedPrimeRateMessage;